<template>
  <div v-if="loadComponent">
    <v-container>
      <h1>Hierarchy Groupings Details</h1>

      <v-row>
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding">
          <hierarchy-group
            :class-padding="classPadding"
            :title="'Hierarchy Group'"
            :label="'Hierarchy Group'"
            v-model="selectedGroup"
            :code-value="false"
          ></hierarchy-group>
        </v-col>
      </v-row>
      
    </v-container>
    <v-container :key="componentKey">
      <v-row>
        <!-- <template v-for="(item, key) in items">
          <org-levels :key="key" :org-level="item.orgLevel"></org-levels>
        </template> -->
        <v-col cols="12" xs="12" sm="6" md="4" :class="classPadding" v-for="(item, key) in items" :key="key">
          <org-levels :key="key" :org-level="item.orgLevel" v-model="orgLevel[`level${key + 1}`]" :level="`Level${key + 1}`"></org-levels>
        </v-col>
      </v-row>
       <v-row>
        <v-col cols="12" xs="12" sm="12" md="12" :class="classPadding">
          <v-btn
            color="success"
            :loading="isSaving"
            :class="classPadding"
            @click.stop="save"
            >Save</v-btn
          >
          &nbsp;
           <v-btn
            :class="classPadding"
            @click.stop="clear"
            >Clear</v-btn
          >
        </v-col>
      </v-row>
      <v-data-table :headers="headers" :items="details" v-if="details.length > 0">
        <template v-slot:item.actions="{item}">
          <v-btn
            @click.stop="deleteItem(item)"
            text
            icon
          >
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-container>
  
    
  </div>
</template>
<script>
import userAccessMixin from "../../../../../mixins/userAccessMixin";
import HierarchyGroup from "../hierarchy-group/Lookup.vue"
import OrgLevels from "./OrgLevels"
const API_ENDPOINT = "/api/hierarchyGroup";
export default {
  mixins: [userAccessMixin],
  data: () => ({
    classPadding: "my-0 py-0",
    model: {},
    selectedGroup: {},
    items: [],
    orgLevel: {
      list: []
    },
    isSaving: false,
    details: [],
    componentKey: 0
  }),
  computed: {
    headers() {
      var items = [
         {
          text: "",
          value: "actions",
          sortable: false
        }
      ];
      var c;
      for(c = 0; c < this.items.length; c++) {
        items.push({
          text: `${this.items[c].orgLevelDesc}`,
          value: `level${c+1}.desc`,
          sortable: false
        })
      }
      return items;
    }
  },
  components: {
    HierarchyGroup,
    OrgLevels
  },
  methods: {
    getOrgLevels(code) {
      this.$axios.get(`${API_ENDPOINT}/gol/${code}`)
        .then(({ data }) => {
          this.items = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
    },
    save() {
      this.isSaving = true
      this.orgLevel.groupCode = this.selectedGroup.code;
      this.$axios.post(`${API_ENDPOINT}/details`, this.orgLevel)
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.reset();
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSaving = false
        })
    },
    getDetails(code) {
      this.$axios.get(`${API_ENDPOINT}/details/${code}`)
        .then(({ data }) => {
          this.details =data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
    },
    deleteItem(item) {
      this.$confirm(this.$deleteConfirm, {
        color: "error",
        title: "Delete"
      }).then(res => {
        if (res) {
          this.$axios
            .delete(`${API_ENDPOINT}/details/${item.id}`)
            .then(({ data }) => {
              this.$toast.success(data.message);
              this.reset();

               this.clear();
            })
            .catch(({ response }) => {
              this.$toast.error(response.data.message);
            });
        }
      });
    },
    reset() {
      this.getOrgLevels(this.selectedGroup.code);
      this.getDetails(this.selectedGroup.code);
    },
    clear() {
      this.orgLevel = {}
      this.componentKey += 1
    }
  },
  watch: {
    selectedGroup(val) {
      this.getOrgLevels(val.code);
      this.getDetails(val.code);

      this.clear();
    },
    orgLevel: {
      handler(val) {
        console.log(val)
      },deep: true
      
    }
  },
  created() {
    this.getUserAccessRights("HierGD");
  }
}
</script>